import RESERVED from './reservedHandles.json';

/**
 * Store mode: stores live at /<handle> and /<handle>/<product-slug>.
 * reservedHandles.json is generated by scripts/gen-reserved-handles.js from
 * every top-level route in App.js (+ a fixed list) -- the same list the
 * backend enforces, so /:storeHandle never shadows a real page.
 */
const RESERVED_SET = new Set(RESERVED);
const HANDLE_RE = /^[a-z0-9-]{3,50}$/;

export function isReservedHandle(handle) {
  return RESERVED_SET.has(String(handle || '').toLowerCase());
}

/** True when a URL segment could be a store handle (format ok, not reserved). */
export function isStoreHandle(handle) {
  return HANDLE_RE.test(handle || '') && !isReservedHandle(handle);
}

export function storePath(handle) {
  return `/${handle}`;
}

/** Canonical product URL: /<handle>/<slug>; falls back to /product/<id>. */
export function productPath(product) {
  if (!product) return '/shop';
  const handle = product.store_handle;
  const slug = product.slug;
  if (handle && slug && isStoreHandle(handle)) return `/${handle}/${slug}`;
  return `/product/${product.id ?? product.product_id}`;
}

export function absoluteUrl(path) {
  if (typeof window === 'undefined') return path;
  return `${window.location.origin}${path}`;
}

export function initialsOf(name) {
  const words = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  const letters = words.length === 1 ? words[0].slice(0, 2) : words[0][0] + words[1][0];
  return letters.toUpperCase();
}
